import { virtualCardsYourCardsRouteProps } from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'
import VirtualCardsFullPaginatedDataReducer, {
  Actions as VirtualCardsFullPaginatedDataActions,
  initialState as initialVirtualCardsFullPaginatedDataState,
  VirtualCardsFullPaginatedDataState,
} from 'src/redux/virtualCardsFullPaginatedData.reducer'

export interface VirtualCardsYourCardsState {
  usersFullPaginatedData: UsersFullPaginatedDataState
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataState
}

export const initialState: VirtualCardsYourCardsState = {
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
  virtualCardsFullPaginatedData: initialVirtualCardsFullPaginatedDataState,
}

export type Actions =
  | UsersFullPaginatedDataActions
  | VirtualCardsFullPaginatedDataActions

const CoreVirtualCardsYourCardsReducer = (
  state = initialState,
  action: Actions,
): VirtualCardsYourCardsState => ({
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataReducer(
    state.virtualCardsFullPaginatedData,
    action as VirtualCardsFullPaginatedDataActions,
  ),
})

const VirtualCardsYourCardsReducer = createBackgroundReducer(
  virtualCardsYourCardsRouteProps,
  initialState,
  CoreVirtualCardsYourCardsReducer,
)

export default VirtualCardsYourCardsReducer
